import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

const VENDOR_OFFERS_PAGE_LIMIT = 500;
const VENDOR_OFFERS_STALE_TIME_MS = 60_000;

interface VendorOffersResponse {
  result?: Array<App.Offer>;
  total?: number;
}

interface UseGetVendorOffersParams {
  enabled?: boolean;
  vendorId?: string;
}

export function useGetVendorOffers({ enabled = true, vendorId }: UseGetVendorOffersParams) {
  return useQuery<Array<App.Offer>>({
    queryKey: ['offers', 'vendor', vendorId],
    queryFn: async () => {
      const offers: Array<App.Offer> = [];
      let page = 1;
      let total: number | undefined;
      let hasNextPage = true;

      while (hasNextPage) {
        const response = (await OffersService.getOffers({
          page,
          limit: VENDOR_OFFERS_PAGE_LIMIT,
          queryString: vendorId,
        })) as VendorOffersResponse;

        const pageOffers = response.result ?? [];
        offers.push(...pageOffers);

        total = response.total ?? total;
        hasNextPage = pageOffers.length > 0 && (total === undefined || offers.length < total);
        page += 1;
      }

      return offers;
    },
    enabled: enabled && !!vendorId,
    staleTime: VENDOR_OFFERS_STALE_TIME_MS,
  });
}
